// The order's ledger rows (GET /orders/:id/ledger) as a small sheet, so staff
// can see what was collected and refunded before deciding on a refund.
import React, { useEffect, useState } from 'react';
import axios from '../../lib/axiosClient';
import { UI, fmtMoney, fmtWhen, useIsNarrow } from './pipeline';

export default function LedgerSheet({ order, onClose }) {
  const narrow = useIsNarrow();
  const [rows, setRows] = useState(null);
  useEffect(() => {
    axios.get(`/api/rentals/orders/${order.id}/ledger`).then(r => setRows(r.data.ledger || [])).catch(() => setRows([]));
  }, [order.id]);
  const tz = order.rental_locations?.timezone;
  const paid = (rows || []).filter(r => r.direction === 'payment').reduce((s, r) => s + Number(r.amount || 0), 0);
  const refunded = (rows || []).filter(r => r.direction === 'refund').reduce((s, r) => s + Number(r.amount || 0), 0);
  return (
    <div style={UI.overlay(narrow)} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={UI.box(narrow, 520)} data-testid="ledger-sheet" role="dialog">
        <div style={UI.head}>
          <div><div style={UI.title}>Ledger — {order.order_number || '#' + order.id}</div><div style={UI.sub}>{order.client_name} · total {fmtMoney(order.total)}</div></div>
          <button style={UI.close} onClick={onClose} aria-label="Close">✕</button>
        </div>
        <div style={UI.body}>
          {rows === null ? <div style={{ color: '#94a3b8', fontSize: 12 }}>Loading…</div>
            : rows.length === 0 ? <div style={{ color: '#94a3b8', fontSize: 12 }}>No money has been recorded on this order.</div>
            : rows.map(r => (
              <div key={r.id} data-testid="ledger-row" style={{ ...UI.row, alignItems: 'flex-start' }}>
                <span>
                  <span style={{ color: r.direction === 'refund' ? '#f87171' : '#4ade80', fontWeight: 700, textTransform: 'capitalize' }}>{r.direction}</span>
                  <span style={{ color: '#94a3b8' }}> · {r.method}{r.stripe_session_id ? ' · Stripe' : ''} · {fmtWhen(r.created_at, tz)}</span>
                  {r.note && <div style={{ color: '#94a3b8', fontSize: 11 }}>{r.note}</div>}
                </span>
                <span style={{ fontWeight: 700, color: r.direction === 'refund' ? '#f87171' : '#f1f5f9', whiteSpace: 'nowrap' }}>{r.direction === 'refund' ? '−' : ''}{fmtMoney(r.amount)}</span>
              </div>
            ))}
          {rows && rows.length > 0 && (
            <div style={{ ...UI.row, marginTop: 6, fontWeight: 800, color: '#f1f5f9', borderBottom: 'none' }}>
              <span>Collected {fmtMoney(paid)}{refunded > 0 ? ` · refunded ${fmtMoney(refunded)}` : ''}</span>
              <span>net {fmtMoney(paid - refunded)} on {fmtMoney(order.total)}</span>
            </div>
          )}
        </div>
        <div style={UI.foot}><button style={{ ...UI.cancelBtn, flex: 1 }} onClick={onClose}>Close</button></div>
      </div>
    </div>
  );
}
